module.exports = __webpack_public_path__ + "img/italy.720aab0f.svg";